import React, { Component } from "react";
import PropTypes from "prop-types";
import DispatchTableHead from "./TableHead";

const MAX_EMPLOYEE = 18;

class EmployeeTable extends Component {
  state = {
    employee: null,
  };

  handleOpenModal = (employee) => {
    const { handleOpenItemModal } = this.props;
    const content = this.modalContent(employee);
    handleOpenItemModal(content);
  };

  handleCloseModal = () => {
    const { handleCloseItemModal } = this.props;
    handleCloseItemModal();
  };

  alphaSortedEmployees = () => {
    const { employees } = this.props;

    return employees.sort((a, b) => {
      if (!a || !b) {
        return 0;
      }

      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
  };

  modalContent = (employee) => {
    if (!employee) {
      return;
    }
    return (
      <div className="details">
        <div className="employee vc">
          <label className="control-label">Nom :</label>
          <div>{employee.name}</div>
        </div>
        <div className="employee vc">
          <label className="control-label">No :</label>
          <div>{employee.employee_number}</div>
        </div>
        <div className="employee vc">
          <label className="control-label">Courriel :</label>
          <div>{employee.email}</div>
        </div>
        <div className="employee vc">
          <label className="control-label">Note :</label>
          <div>{employee.note}</div>
        </div>
      </div>
    );
  };

  render() {
    const {
      employees,
      handleToggleItemModal,
      handleDeleteClick,
      copyType,
      handleCopy,
      handlePaste,
      userType,
    } = this.props;
    const employeeLength = employees.length ? employees.length : 0;
    const emptyCells = new Array(
      Math.max(MAX_EMPLOYEE - employeeLength, 0)
    ).fill(0);

    return (
      <div className="right">
        <table className="employees">
          <DispatchTableHead
            numberOfItems={employeeLength}
            title="ouvriers"
            span={2}
            onAddClick={() => handleToggleItemModal(0)}
            active={copyType === "employees"}
            userType={userType}
            onOptionClick={() =>
              copyType === "employees" ? handlePaste() : handleCopy()
            }
          />
          <tbody>
            {this.alphaSortedEmployees().map((employee) => {
              if (employee) {
                return (
                  <tr key={employee.id}>
                    <td
                      className={employee.note ? "has_note" : ""}
                      onClick={() => this.handleOpenModal(employee)}
                    >
                      {employee.name}
                    </td>
                    {userType === "admin" && (
                      <td
                        className="delete-icon"
                        onClick={() => handleDeleteClick(employee.id)}
                      >
                        <i className="fa fa-times" aria-hidden="true" />
                      </td>
                    )}
                  </tr>
                );
              }
              return <React.Fragment></React.Fragment>;
            })}
            {emptyCells.map((cell, index) => (
              <tr className="empty" key={`empty-${index}`}>
                <td />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

EmployeeTable.propTypes = {
  employees: PropTypes.array,
  handleToggleItemModal: PropTypes.func,
  handleDeleteClick: PropTypes.func,
};

export default EmployeeTable;
